import { Model } from './model';
import { Specie } from './specie';
import { Zone } from './zone';

export class StockMinimal extends Model {
  id: number;
  name: string;
  pseudonym: string;
  species: Specie[] = [];
  full_name: string;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    const stock_minimal = new StockMinimal(values);

    stock_minimal.full_name = `${stock_minimal.name} ${stock_minimal.pseudonym}`;

    if (values['species']) {
      for (const specie of values['species']) {
        stock_minimal.species.push(new Specie(specie));
      }
    }
    return stock_minimal;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/stock-minimal.ts